import { useTranslation } from '@aimsos/i18n';

import NextBestActionActionButton from './NextBestActionActionButton.jsx';
import NextBestActionSection from './NextBestActionSection.jsx';

/** "Other recommendations — also flagged, ranked below this one" (CT-5713). */
function NextBestActionOtherList({ items, entity, onAction }) {
  const { t } = useTranslation('unified-profiles');

  if (!items.length) return null;

  return (
    <NextBestActionSection title={t('profile.nba.others')}>
      <p className="text-sm text-content-muted">{t('profile.nba.othersHint')}</p>
      <ul className="flex flex-col gap-4">
        {items.map((other) => (
          <li key={other.id} className="flex flex-col gap-1 text-sm">
            <span className="font-medium text-content">{other.title}</span>
            <span className="text-content-secondary">{[other.context, other.description].filter(Boolean).join(' ')}</span>
            <div>
              <NextBestActionActionButton
                item={other}
                action={other.primaryAction}
                variant="secondary"
                entity={entity}
                onAction={onAction}
              />
            </div>
          </li>
        ))}
      </ul>
    </NextBestActionSection>
  );
}

export default NextBestActionOtherList;
